if (typeof window.modalChangeType === "undefined") {
  window.modalChangeType = async () => {
    const changeToSettings = {
      item_name: "",
      selling_type: "",
      product_type: "default",
      payload: "",
    };
    const MODULE_NAME = "Modal Change Type";
    const ALLOWED_DELIVERY_FREQUENCY = ["2", "4", "6"];
    const MODAL_CHANGE_TYPE_SUBSCRIPTION_IDENTIFIER =
      "#modal-change-to-subscription";
    const MODAL_CHANGE_TYPE_ONEOFF_IDENTIFIER = "#modal-change-to-one-off";

    const printLog = (message) => {
      console.log(
        `%c${MODULE_NAME}`, // Module Name
        "font-weight: bold; color: #000; background: #c7facd; border-radius: 3px; padding-left: 5px; padding-right: 5px;",
        message
      );
    };
    
    const validateRequiredScripts = async (timeout = 5000) => {
      const start = Date.now();

      while (true) {
        const hasJQuery = typeof window.jQuery === "function";
        const hasStockmanSteaks = typeof window.stockmansteaks !== "undefined";

        if (hasJQuery && hasStockmanSteaks) {
          break;
        }

        if (Date.now() - start >= timeout) {
          break;
        }

        await new Promise(resolve => setTimeout(resolve, 50)); // wait 50ms before rechecking
      }
    };

    const generateBundleId = async () => {
      // Local Bundle ID
      const chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let randomStr = "";

      for (let i = 0; i < 9; i++) {
        randomStr += chars.charAt(Math.floor(Math.random() * chars.length));
      }

      const randomNum =
        Math.floor(Math.random() * 9_000_000_000_000) + 1_000_000_000_000; // Ensures 13 digits

      const localBundleId = `${randomStr}:${randomNum}`;

      // Build a box can use the localBundleId
      if (changeToSettings.product_type === 'build-a-box') {
        return localBundleId;
      }

      return localBundleId;

      // TODO: Remove below since we are not using recharge anymore

      // Recharge Bundle ID
      try {
        const possibility = window.modalChangeTypePossibility.find(
          (item) => item.key === changeToSettings.payload
        );

        // We only care when switching to linked product
        if (!possibility.linked_product_purchase_type) {
          printLog("Unable to find linked_product_purchase_type");
          return localBundleId;
        }

        let fixedPriceBundleType = null;
        if (changeToSettings.item_name.includes("small sized custom box")) {
          fixedPriceBundleType = "small-custom-box";
        } else if (changeToSettings.item_name.includes("custom box")) {
          fixedPriceBundleType = "default-custom-box";
        } else if (changeToSettings.item_name.includes("value box")) {
          fixedPriceBundleType = "value-box";
        } else {
          printLog("Not a fixed price bundle");
          // Not a fixed price bundle
          return localBundleId;
        }

        // Generate the selections
        let identifierMenuA = null;
        let identifierMenuB = null;

        if (!window.modalChangeTypeCollections) {
          throw new Error("modalChangeTypeCollections not found");
        }

        switch (fixedPriceBundleType) {
          case "default-custom-box":
            identifierMenuA = "default_custom_box_menu_a";
            identifierMenuB = "default_custom_box_menu_b";
            break;
          case "small-custom-box":
            identifierMenuA = "small_custom_box_menu_a";
            identifierMenuB = "small_custom_box_menu_b";
            break;
          case "value-box":
            identifierMenuA = "default_value_box";
            identifierMenuB = null;
            break;
          default:
            throw new Error(
              `Invalid fixedPriceBundleType: ${fixedPriceBundleType}`
            );
        }

        if (typeof possibility.properties.Contents === "undefined") {
          throw new Error("Contents not found in possibility properties");
        }

        const fixedPriceBundleCollectionA = identifierMenuA
          ? window.modalChangeTypeCollections[identifierMenuA]
          : null;
        const fixedPriceBundleCollectionB = identifierMenuA
          ? window.modalChangeTypeCollections[identifierMenuB]
          : null;

        const collectionIdMenuA = fixedPriceBundleCollectionA?.collection_id;
        const collectionIdMenuB = fixedPriceBundleCollectionB?.collection_id;

        const collectionItemsMenuA = fixedPriceBundleCollectionA?.items || [];
        const collectionItemsMenuB = fixedPriceBundleCollectionB?.items || [];

        const hashedCollectionItemsMenuA = collectionItemsMenuA.reduce(
          (acc, item) => {
            acc[item.name] = item;
            return acc;
          },
          {}
        );

        const hashedCollectionItemsMenuB = collectionItemsMenuB.reduce(
          (acc, item) => {
            acc[item.name] = item;
            return acc;
          },
          {}
        );

        const selections = [];

        const contents = possibility.properties.Contents.split("\n").map(
          (item) => item.trim()
        );

        for (const content of contents) {
          const breakdown = content.trim().match(/(\d+x)\s(.+)/);
          const name = breakdown[2]?.trim();
          const qty = parseInt(breakdown[1].replace(/\D/g, ""));

          // Check A
          const selectionPayload = {
            collectionId: "",
            externalProductId: "",
            externalVariantId: "",
            quantity: qty,
          };

          if (hashedCollectionItemsMenuA[name]) {
            selectionPayload.collectionId = collectionIdMenuA;
            selectionPayload.externalProductId =
              hashedCollectionItemsMenuA[name].product_id;
            selectionPayload.externalVariantId =
              hashedCollectionItemsMenuA[name].variant_id;
          } else if (hashedCollectionItemsMenuB[name]) {
            selectionPayload.collectionId = collectionIdMenuB;
            selectionPayload.externalProductId =
              hashedCollectionItemsMenuB[name].product_id;
            selectionPayload.externalVariantId =
              hashedCollectionItemsMenuB[name].variant_id;
          } else {
            throw new Error(`Item not found in any collection: ${name}`);
          }

          selections.push(selectionPayload);
        }

        const payload = {
          externalProductId:
            possibility.linked_product_purchase_type.product_id, // Bundle's Shopify Product ID
          externalVariantId:
            possibility.linked_product_purchase_type.variant_id, // Bundle's Shopify Variant ID
          selections: selections,
        };

        const bundleId = await recharge.bundle.getBundleId(payload);

        return bundleId;
      } catch (error) {
        console.log({ error });
        printLog(error);
      }

      return localBundleId;
    };

    const toggleModal = ($el, value) => {
      const $body = $("body");
      const $modal = $el.hasClass("modal-mini")
        ? $el
        : $el.closest(".modal-mini");

      if (value) {
        $modal.fadeIn("fast");
        $body.addClass("modal-mini-active");
      } else {
        $modal.fadeOut("fast");
        $body.removeClass("modal-mini-active");
      }
    };

    const setup = ($el) => {
      const item_name = $el.data("cart-item-title");
      const selling_type = $el.data("change-to");
      const product_type = $el.data("change-to-product-type");
      const payload = String($el.data("change-to-payload"));

      changeToSettings.item_name = item_name;
      changeToSettings.selling_type = selling_type;
      changeToSettings.product_type = product_type;
      changeToSettings.payload = payload
        .split(",")
        .map((item) => item.trim())
        .join(",");

      validateSettings();
    };

    const validateSettings = () => {
      const allowedSellingTypes = ["subscription", "one-off"];
      const allowedType = ["default", "build-a-box"];

      if (!allowedSellingTypes.includes(changeToSettings.selling_type)) {
        console.error("Invalid selling types");
        return false;
      }

      if (!allowedType.includes(changeToSettings.product_type)) {
        console.error("Invalid product type");
        return false;
      }

      if (!changeToSettings.item_name) {
        console.error("Invalid item name");
        return false;
      }

      if (!changeToSettings.payload) {
        console.error("Invalid payload");
        return false;
      }

      if (typeof window.modalChangeTypePossibility === "undefined") {
        console.error("No possibility data found");
        return false;
      }

      return true;
    };

    const submitModal = ($el) => {
      const $form = $el;
      const $modal = $el.closest(".modal-mini");
      const $submit = $form.find("[type=submit]");
      const $spinner = $form.find(".loading-overlay__spinner");
      const $deliveryFrequency = $form.find("[name=delivery_frequency]");
      const deliveryFrequency = $deliveryFrequency
        ? $deliveryFrequency.val()
        : null;

      const toggleFormLoading = (value) => {
        if (value) {
          $submit.addClass("loading");
          $submit.attr("disabled", "disabled");
          $spinner.removeClass("hidden");
        } else {
          $submit.removeClass("loading");
          $submit.removeAttr("disabled");
          $spinner.addClass("hidden");
        }
      };

      // Validate delivery frequency
      if (
        deliveryFrequency !== null &&
        deliveryFrequency !== undefined &&
        !ALLOWED_DELIVERY_FREQUENCY.includes(deliveryFrequency)
      ) {
        toggleErrorNotification($form, true);
        console.error("Invalid delivery frequency", deliveryFrequency);
        return;
      }

      processData(toggleFormLoading, deliveryFrequency).then(() => {
        toggleModal($modal, false);
      });
    };

    const processData = async (toggleFormLoading, deliveryFrequency = null) => {
      const newSellingType = changeToSettings.selling_type;
      const payloadList = changeToSettings.payload.split(",");

      if (!payloadList.length) {
        toggleFormLoading(false);
        return;
      }

      toggleFormLoading(true);

      const newBundleId = await generateBundleId();
      const possibilities = window.modalChangeTypePossibility;

      printLog(newBundleId);

      if (!possibilities) {
        console.error("Unable to find window.modalChangeTypePossibility");
        return;
      }

      const removePayload = {};
      const addPayload = [];

      payloadList.forEach((payload) => {
        // Find based on the key
        const possibility = possibilities.find((possibility) => {
          // printLog({
          //   possibility,
          //   possibilityKey: possibility.key,
          //   payload,
          //   result: possibility.key == payload,
          // });
          return possibility.key == payload;
        });

        if (!possibility) {
          printLog("No possibility found for", payload);
          return;
        }

        const addPayloadResponse =
          newSellingType === "subscription"
            ? handleSubscription(possibility, newBundleId, deliveryFrequency)
            : handleOneOff(possibility, newBundleId);
        if (!addPayloadResponse) {
          printLog(
            "Something went wrong when creating addPayloadResponse",
            addPayloadResponse
          );
          return;
        }

        addPayload.push(addPayloadResponse);
        removePayload[possibility.key] = 0;
      });

      // Handle delete
      if (Object.values(removePayload).length > 0) {
        const response = await fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates: removePayload,
            sections: window.stockmansteaks.getCartSectionsParam(),
            sections_url: window.location.pathname,
          }),
        }).then((response) => {
          return response.json();
        });
        
        window.stockmansteaks.replaceSections(response);
        window.stockmansteaks.toggleCartEmpty(response.item_count === 0);

        await new Promise((resolve) => setTimeout(resolve, 2500));
      }

      // Handle add
      if (addPayload.length > 0) {
        const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: addPayload,
            sections: window.stockmansteaks.getCartSectionsParam(),
            sections_url: window.location.pathname,
          }),
        }).then((response) => {
          return response.json();
        });
        
        window.stockmansteaks.replaceSections(response);
        window.stockmansteaks.toggleCartEmpty(response.item_count === 0);

        await new Promise((resolve) => setTimeout(resolve, 2500));
      }

      toggleFormLoading(false);
      // window.location.reload();
    };

    const findSellingPlanId = (list, target) => {
      // Find based on the item.name if it contains the target
      return list.find((item) => item.name.includes(target))?.id;
    };

    const handleSubscription = (
      possibility,
      newBundleId,
      deliveryFrequency
    ) => {
      // Switch to linked product
      if (possibility.linked_product_purchase_type) {
        const sellingPlanId = findSellingPlanId(
          possibility.linked_product_purchase_type.selling_plan_ids,
          deliveryFrequency
        );

        const payload = {
          id: possibility.linked_product_purchase_type.variant_id,
          quantity: possibility.quantity,
          selling_plan: sellingPlanId,
          properties: {
            ...possibility.properties,
          },
        };
        
        if (typeof payload.properties._rb_id !== "undefined") {
          payload.properties._rb_id = newBundleId;
        }

        printLog(payload);

        return payload;
      }

      // Switch the product selling plan's
      if (
        possibility.selling_plan_ids &&
        possibility.selling_plan_ids.length > 0
      ) {
        const sellingPlanId = findSellingPlanId(
          possibility.selling_plan_ids,
          deliveryFrequency
        );
        printLog(`handleSubscription - update selling plan to: ${sellingPlanId}`);

        if (!sellingPlanId) {
          return;
        }

        let properties = {
          ...possibility.properties,
        };

        if (typeof properties._rb_id !== "undefined") {
          properties._rb_id = newBundleId;
        }

        if (typeof properties._rc_bundle !== "undefined") {
          properties._rc_bundle = newBundleId;
        }

        if (typeof properties._rc_bundle_parent !== "undefined") {
          properties._rc_bundle_parent = "build-a-box-subscription";
        }

        if (
          typeof properties._rc_bundle_variant !== "undefined" &&
          properties._rc_bundle_variant == window.buildABoxVariantId
        ) {
          properties._rc_bundle_variant = window.buildABoxSubscriptionVariantId;
        }

        const payload = {
          id: possibility.variant_id,
          quantity: possibility.quantity,
          selling_plan: sellingPlanId,
          properties: properties,
        };

        return payload;
      }

      return null;
    };

    const handleOneOff = (possibility, newBundleId) => {
      // Switch to linked product
      if (possibility.linked_product_purchase_type) {
        const payload = {
          id: possibility.linked_product_purchase_type.variant_id,
          quantity: possibility.quantity,
          selling_plan: null,
          properties: {
            ...possibility.properties,
          },
        };
        
        if (typeof payload.properties._rb_id !== "undefined") {
          payload.properties._rb_id = newBundleId;
        }
        
        printLog(payload);

        return payload;
      }

      let properties = {
        ...possibility.properties,
      };
      
      if (typeof properties._rb_id !== "undefined") {
        properties._rb_id = newBundleId;
      }

      if (typeof properties._rc_bundle !== "undefined") {
        properties._rc_bundle = newBundleId;
      }

      if (typeof properties._rc_bundle_parent !== "undefined") {
        properties._rc_bundle_parent = "build-a-box";
      }

      if (
        typeof properties._rc_bundle_variant !== "undefined" &&
        properties._rc_bundle_variant == window.buildABoxVariantId
      ) {
        properties._rc_bundle_variant = window.buildABoxVariantId;
      }

      const payload = {
        id: possibility.variant_id,
        quantity: possibility.quantity,
        selling_plan: null,
        properties: properties,
      };

      return payload;
    };

    const toggleErrorNotification = ($parent, show) => {
      const $errorNotification = $parent.find(".notification-box");

      if ($errorNotification.length <= 0) {
        return;
      }

      if (show) {
        $errorNotification.slideDown("fast");
      } else {
        $errorNotification.slideUp("fast");
      }
    };

    await validateRequiredScripts();

    // Hook
    $(document).on("submit", "[data-change-to-form]", function (e) {
      e.preventDefault();

      submitModal($(this));
    });

    $(".modal-mini").on("click", "[data-close-modal]", function (e) {
      e.preventDefault();
      toggleModal($(this), false);
    });

    $(document).on("click", "[data-change-to]", function (e) {
      e.preventDefault();
      setup($(this));

      if (changeToSettings.selling_type === "subscription") {
        toggleModal($(MODAL_CHANGE_TYPE_SUBSCRIPTION_IDENTIFIER), true);
      } else {
        toggleModal($(MODAL_CHANGE_TYPE_ONEOFF_IDENTIFIER), true);
      }
    });

    // Start
    printLog("modal-change-type.js loaded");
  };

  (function () {
    if (document.readyState === 'loading') {
      // DOM is still loading, wait for it
      document.addEventListener('DOMContentLoaded', function () {
        window.modalChangeType();
      });
    } else {
      // DOM is already loaded, run immediately
      window.modalChangeType();
    }
  })();
}
